import axios from 'axios';
import { ROUTE_OPTIMIZER_URL } from '../../../app/utils';

export const optimizeRoute = async (pickUpCoord, dropOffOrders) => {
  const points = [
    { Name: "pickup", X: pickUpCoord.longitude, Y: pickUpCoord.latitude },
    ...dropOffOrders.map(order => ({
      Name: order.id,
      X: order.dropOffLocation.coordinate.longitude,
      Y: order.dropOffLocation.coordinate.latitude,
    }))
  ];
  return axios.post(`${ROUTE_OPTIMIZER_URL}/route`, { points });
};
